var _mask, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConcernsicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1978_9335",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16V14C4.68629 14 2 11.3137 2 8H0H-2C-2 13.5228 2.47715 18 8 18V16ZM16 8H14C14 11.3137 11.3137 14 8 14V16V18C13.5228 18 18 13.5228 18 8H16ZM8 0V2C11.3137 2 14 4.68629 14 8H16H18C18 2.47715 13.5228 -2 8 -2V0ZM8 0V-2C2.47715 -2 -2 2.47715 -2 8H0H2C2 4.68629 4.68629 2 8 2V0Z",
    fill: "url(#paint0_linear_1978_9335)",
    mask: "url(#path-1-inside-1_1978_9335)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11523 3.46875L8.03906 9.5918H7.06055L6.97852 3.46875H8.11523ZM6.94336 11.4551C6.94336 11.2793 6.99609 11.1309 7.10156 11.0098C7.21094 10.8887 7.37109 10.8281 7.58203 10.8281C7.78906 10.8281 7.94727 10.8887 8.05664 11.0098C8.16992 11.1309 8.22656 11.2793 8.22656 11.4551C8.22656 11.623 8.16992 11.7676 8.05664 11.8887C7.94727 12.0098 7.78906 12.0703 7.58203 12.0703C7.37109 12.0703 7.21094 12.0098 7.10156 11.8887C6.99609 11.7676 6.94336 11.623 6.94336 11.4551Z",
    fill: "url(#paint1_linear_1978_9335)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1978_9335",
    x1: 0,
    y1: 8,
    x2: 16,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1978_9335",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcernsicon);
export default __webpack_public_path__ + "static/media/Concerns icon.49219a7d516de64301e03681cf627e54.svg";
export { ForwardRef as ReactComponent };